<template>
  <select-with-buttons :options="
                       [ null, {text: 'N', value: 0, class: ['scoreButton']}, null,
                         {text: 'W', value: 3, class: ['scoreButton']}, null, {text: 'E', value: 1, class: ['scoreButton']},
                         null, {text: 'S', value: 2, class: ['scoreButton']}, null]"
                       row-size="3"
                       @click="propagateClick"></select-with-buttons>
</template>

<script>
import SelectWithButtons from '../lib/SelectWithButtons';

export default {
  name: 'SelectPlayer',
  components: {SelectWithButtons},
  props: {},
  methods: {
    propagateClick(clicked) {
      this.$emit('click', clicked);
    }
  }
};
</script>

<style scoped>

>>> .scoreButton {
  background: white;
  border: 1px solid #3396B8;
}
</style>